import * as React from "react";
var InputGroupAddon = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "wds-input-group__addon" }, children));
};
export default InputGroupAddon;
//# sourceMappingURL=InputGroupAddon.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@sm/smapply-ui/dist/es/components/InputGroup/InputGroupAddon.js
// module id = 1784
// module chunks = 17